import React from 'react'
// components
import DetailsForm from './components/DetailsForm'
import PlanLinks from 'components/Modals/PlanItems/components/PlanLinks'
import AdditionalModalActions from 'components/Modals/PlanItems/components/AdditionalModalActions'
// context
import { ObjectiveContext } from 'context'
import { DetailsModalActionsContext } from 'containers/MinimizedObjectivesList/layers/Business/DetailsModalActions'
// hocs
import { withDropzone } from 'hocs'
// hooks
import { useInitialValues } from 'hooks'
// constants
import { ENTITIES, Forms } from 'constants/index'
// graphql
import { PLAN_OBJECTIVE_DETAILS_QUERY } from 'graphql/planObjectives/queries'
// views
import { DetailsSectionWrapper as Wrapper } from 'components/Modals/PlanItems/styles'

const DetailsSection = ({ hideModal, isFullModal, modalData, isReadOnly, form = Forms.OBJECTIVE_DETAILS_FORM }) => {
  const { entity, plan, handleDetailsSubmit, getInitialValues } = React.useContext(ObjectiveContext)
  const { shouldShowModalActions } = React.useContext(DetailsModalActionsContext)

  const initialValues = useInitialValues(getInitialValues, entity)

  return (
    <Wrapper $isFullModal={isFullModal} $shouldShowModalActions={shouldShowModalActions}>
      <DetailsForm
        form={form}
        isReadOnly={isReadOnly}
        hideModal={hideModal}
        initialValues={initialValues}
        key={entity.id}
        objective={entity}
        onSubmit={handleDetailsSubmit}
      />
      <PlanLinks
        entity={entity}
        disabled={isReadOnly || plan.locked}
        query={PLAN_OBJECTIVE_DETAILS_QUERY}
        variables={{
          filter: {
            ids: [entity.id]
          }
        }}
      />
      {shouldShowModalActions && !isReadOnly && (
        <AdditionalModalActions
          entity={{ ...entity, entityType: ENTITIES.PLAN_OBJECTIVE, planId: plan.id }}
          hideModal={hideModal}
          isSubPlan={modalData.isSubPlan}
          plan={modalData.parentPlan}
          sourceItems={modalData.sourceItems}
        />
      )}
    </Wrapper>
  )
}

export default withDropzone(DetailsSection)
